<template>
  <div>
    <div class="replay-field">
      <div class="replay-label">Select Name</div>
      <div class="game-select" :data-value="value">
        <div class="game-selector" @click="toggleGameList()" @focusout="handleFocusOut" tabindex="0">
          <div class="game-label">
            <span :class="{ placeholder: value === 'Name' }">{{ value }}</span>
          </div>
          <div class="arrow" :class="{ expanded : visible }"></div>
          <div :class="{ hidden : !visible, visible }">
            <ul>
              <li :class="{ current : item === value }" v-for="item in replayGameType === 'Fantasma' ? fantasmaGamesList : armadilloGamesList" :key="item.id" @click="selectGame(item)">{{`${item.id} (Name: ${item.name})`}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="replay-field">
      <div class="replay-label">Enter Round ID</div>
      <input v-model="roundId" id="round-id-input" class="replay-value" type="text" name="roundId" autocomplete="off" placeholder="Round ID" v-on:input="onReplayValueChange()">
    </div>
    <div class="replay-actions">
      <button class="action" :class="{ disabled: !gameId || !roundId || isReplayError }" :disabled="!gameId || !roundId || isReplayError" v-on:click="playGameReplay()">
        <svg-icon type="mdi" size="32" :path="mdiPlayCircleOutline"></svg-icon>
      </button>
      <button class="action" :class="{ disabled: !gameId || !roundId || isReplayError }" :disabled="!gameId || !roundId || isReplayError" v-on:click="copyReplayGameUrl()">
        <svg-icon type="mdi" size="32" :path="mdiContentCopy"></svg-icon>
      </button>
      <button v-if="isReplayActive" class="action" :class="{ disabled: !gameId || !roundId || isReplayError }" :disabled="!gameId || !roundId || isReplayError" v-on:click="closeGameReplay()">
        <svg-icon type="mdi" size="32" :path="mdiCloseCircleOutline"></svg-icon>
      </button>
    </div>
    <div v-if="isReplayError" id="error" class="error-section">
      <div id="error-title" class="error-title" data-translation="fetch_error">Round not found</div>
    </div>
    <div v-if="isReplayActive" id="game-player" class="game-frame">
      <iframe id="game" style="max-width: 90%; aspect-ratio: 16/9; height: auto; width: 1100px; background-color: #000000" allow="clipboard-read *; clipboard-write *" :src="replayGameType === 'Fantasma' ? getFantasmaReplayGameUrl() : getArmadilloReplayGameUrl()"></iframe>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import {mdiCloseCircleOutline, mdiContentCopy, mdiPlayCircleOutline} from '@mdi/js'

export default {
  name: 'GameReplaySection',
  props: {
    replayGameType: {
      type: String
    }
  },
  components: {SvgIcon},
  data () {
    return {
      baseUrl: 'https://games.rgsreplay.com',
      gameId: '',
      roundId: '',
      isReplayActive: false,
      isReplayError: false,
      visible: false,
      mdiCloseCircleOutline: mdiCloseCircleOutline,
      mdiContentCopy: mdiContentCopy,
      mdiPlayCircleOutline: mdiPlayCircleOutline,
      value: 'Name',
      armadilloGamesList: [
        // Removing game until it is deployed to prod
        // {
        //   id: 'PiggyGoldCoinsGK94',
        //   name: 'Piggy Gold Coins'
        // },
        {
          id: 'PiggyGoldCoinsGK96',
          name: 'Piggy Gold Coins'
        },
        {
          id: 'DDDGK96',
          name: 'Diamond Diamond Diamond'
        },
        {
          id: 'DragonMayhemGK96',
          name: 'Dragon Mayhem GK96'
        },
        {
          id: '4GodsOfRagnarokGK96',
          name: '4 Gods of Ragnarok'
        }
      ],
      fantasmaGamesList: [
        // Removing games until they deployed to prod
        // {
        //   id: 'goldpigger',
        //   name: 'Gold Pigger'
        // },
        // {
        //   id: 'goldpigger_94',
        //   name: 'Gold Pigger 94'
        // },
        // {
        //   id: 'vulcansgold',
        //   name: 'Vulcan\'s Gold'
        // },
        // {
        //   id: 'vulcansgold_94',
        //   name: 'Vulcan\'s Gold 94'
        // },
        // {
        //   id: 'medallion',
        //   name: 'Medallion'
        // },
        // {
        //   id: 'medallion_94',
        //   name: 'Medallion 94'
        // },
        {
          id: 'dragonduellogk',
          name: 'Dragon Duello'
        }
      ]
    }
  },
  methods: {
    handleFocusOut () {
      this.visible = false
    },
    toggleGameList () {
      this.visible = !this.visible
    },
    selectGame (game) {
      this.value = `${game.id} (Name: ${game.name})`
      if (game.id && game.id === 'DDDGK96') {
        this.gameId = 'DiamondDiamondDiamondGK96'
        return
      }

      this.gameId = game.id
    },
    getGameReplayError () {
      this.isReplayError = !/^[a-z,0-9-]{36}$/.test(this.roundId)
    },
    onReplayValueChange () {
      if (this.isReplayActive) {
        this.isReplayActive = false
      }
      this.getGameReplayError()
    },
    playGameReplay () {
      this.getGameReplayError()
      if (!this.isReplayError) {
        this.isReplayActive = true
      }
    },
    copyReplayGameUrl () {
      this.getGameReplayError()
      if (!this.isReplayError) {
        window.navigator.clipboard.writeText(this.replayGameType === 'Fantasma' ? this.getFantasmaReplayGameUrl() : this.getArmadilloReplayGameUrl())
      }
    },
    closeGameReplay () {
      this.isReplayActive = false
    },
    getArmadilloReplayGameUrl () {
      const language = 'en'

      return `${this.baseUrl}/${this.gameId === 'DragonMayhemGK96' ? 'DragonMayhemGK' : this.gameId}/index.html?game=${this.gameId}&language=${language}&${this.gameId === '4GodsOfRagnarokGK96' ? 'replay' : 'replayID'}=${this.roundId}`
    },
    getFantasmaReplayGameUrl () {
      return `${this.baseUrl}/fantasmagames/${this.gameId}/index.html?game=${this.gameId}&roundId=${this.roundId}&language=en_gb&server=${this.baseUrl}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GameReplaySection.vue